import Column from '../../components/Column';
import Row from '../../components/Row';
import AccessDenyCallout from './AccessDenyCallout';

const AccessDeniedPage = () => {
    return (
        <Column gap={0} flex={1}>
            <Row width="100%" justifyContent="center" sx={{ p: 9 }}>
                <AccessDenyCallout />
            </Row>
        </Column>
    );
};

export default AccessDeniedPage;
